module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Display-65-f11cc3deff3af7fa8ae25dc41f59425a.woff2";